import { environment } from "../../environments/environment";

export class AppConstants {
  public static REQUEST_STATUS = {
    NEW_REQUEST: 1,
    ACKNOWLEDGED: 2,
    IN_PROGRESS: 3,
    COMPLETED: 4,
    REJECTED: 5,
    CANCELLED: 6,
  };
  public static REQUEST_SLA = {
    CAR_REQUEST:
      "SLA for resolving this request is 3 Working Days. DISCLAIMER: Timelines may vary subject to practical situation & condition of the issues.",
    DRIVER_CONCERN:
      "SLA for resolving this request is 3 Working Days. DISCLAIMER: Timelines may vary subject to practical situation & condition of the issues.",
    HOUSE_REQUEST:
      "SLA for resolving this request is 3 Working Days. DISCLAIMER: Timelines may vary subject to practical situation & condition of the issues.",
    HOUSE_RELOCATION:
      "SLA for resolving this request is 30 days after completion of survey. DISCLAIMER: Timelines may vary subject to practical situation & condition of the issues.",
  };
  public static StatusColor = {
    RED: "#f00",
    ORANGE: "#ff9900",
    GREEN: "#a2f86c",
  };
  public static StatusCssClass = { ELAPSED: "elapsed" };

  /* Environment */
  public static get env(): string {
    return environment.envName;
  }
  //  public static get env(): string { return `Prod` }

  public static get cryptoKey(): string {
    return "!QAZDFRTVUI&^%$()MNIIUVYFFV%&8746";
  }
  public static get defaultPassword(): string {
    return "password123";
  }
  public static get HOME_SCREEN(): string {
    return `home`;
  }
  public static get FINISHED_SCREEN(): string {
    return `finished`;
  }
  public static get REMAINING_SCREEN(): string {
    return `remaining`;
  }
  public static get filterend(): string {
    return `" } `;
  }
  public static get filterIntend(): string {
    return `} `;
  }
  public static get schduledDateFilterCons(): string {
    return ` scheduled_date : { contains :"`;
  }
  public static get userIdFilterCons(): string {
    return ` user_id : { eq :"`;
  }
  public static get driverIDFilterCons(): string {
    return ` driver_id : { eq :"`;
  }
  public static get driverIDsFilterCons(): string {
    return ` driver_id : "`;
  }
  public static get orFilterCons(): string {
    return ` or : `;
  }
  public static get orFilterConsEnd(): string {
    return `""`;
  }
  public static get tripTypeFilterCons(): string {
    return ` trip_type : { eq :`;
  }
  public static get tripStatusFilterCons(): string {
    return ` trip_status : { eq :`;
  }
  public static get userNameFilterCons(): string {
    return ` user_name : { eq :"`;
  }
  public static get userTypeFilterCons(): string {
    return ` user_type : { eq :`;
  }
  public static get agencyTypeFilterCons(): string {
    return ` agency_type : { eq :"`;
  }

  public static get vehicleNoFilterCons(): string {
    return ` vehicle_no : { eq :"`;
  }

  public static get Success(): string {
    return `Success`;
  }
  public static get Error(): string {
    return `Error`;
  }
  public static get Warning(): string {
    return `Warning`;
  }

  public static get VehicleMasterError(): string {
    return `Error in creating Personal Driver to User mapping, Re Upload Required`;
  }
  public static get VehicleMasterUserExists(): string {
    return `User Already Exists`;
  }
  public static get AddressNotFound(): string {
    return `Addresss is not valid`;
  }
  public static get UserTripAddressUpdateFailed(): string {
    return `Unable to Update User Trip Address`;
  }
  public static get UserTripCreationFailed(): string {
    return `Unable to create User Trip`;
  }
  public static get TripCreationFailed(): string {
    return `Unable to create Trip for this driver`;
  }
  public static get CabCreationFailed(): string {
    return `Unable to create Cab for this driver`;
  }
  public static get DriverNotAvailable(): string {
    return `Driver ID not available`;
  }
  public static get UserCreationFailed(): string {
    return `Unable to create User`;
  }
  public static get InvalidRNNumber(): string {
    return `Invalid RN NUmber`;
  }
  public static get NewRNNumber(): string {
    return `New Employee, Request Admin team to add the user`;
  }
  public static get PhoneNumberError(): string {
    return `Invalid Phone/Emergency Number`;
  }

  /* Actions */
  public static get update(): string {
    return `update`;
  }
  public static get getq(): string {
    return `get`;
  }
  public static get create(): string {
    return `create`;
  }
  public static get delete(): string {
    return `delete`;
  }
  public static get list(): string {
    return `list`;
  }

  /* Table Names */
  public static get ScCabMaster(): string {
    return `ScCabMaster`;
  }
  public static get ScSos(): string {
    return `ScSos`;
  }
  public static get ScSosMaster(): string {
    return `ScSosMaster`;
  }
  public static get ScTripMaster(): string {
    return `ScTripMaster`;
  }
  public static get ScTripPosition(): string {
    return `ScTripPosition`;
  }
  public static get ScUserTrip(): string {
    return `ScUserTrip`;
  }
  public static get DaTrips(): string {
    return `DaTrips`;
  }
  public static get RnHrbotKeymapsSuggestions(): string {
    return `RnhrbotKeymapsSuggestions`;
  }

  public static get AppFitnessFeedback(): string {
    return `AppFitnessFeedback`;
  }
  public static get DaVehicleMaster(): string {
    return `DaVehicleMaster`;
  }
  public static get RncUsers(): string {
    return `RncUsers`;
  }
  public static get ScMetaData(): string {
    return `ScMetaData`;
  }

  /* List Items */
  public static get listDaVehicleMasters(): string {
    return `DaVehicleMasters`;
  }
  public static get listScCabMasters(): string {
    return `ScCabMasters`;
  }
  public static get listScTripMasters(): string {
    return `ScTripMasters`;
  }
  public static get listScSos(): string {
    return `ScSos`;
  }
  public static get listAppFitnessFeedback(): string {
    return `AppFitnessFeedbacks`;
  }
  public static get listScSosMasters(): string {
    return `ScSosMasters`;
  }
  public static get listScUserTrips(): string {
    return `ScUserTrips`;
  }

  /* Car Data List 2019 */
  public static get listCpVehicleMaster(): string {
    return `CpVehicleMasters`;
  }
  public static get updateCpVehicleMaster(): string {
    return `CpVehicleMaster`;
  }

  /* Car Assigned List 2019 */
  public static get listCpAssignedCar(): string {
    return `CpAssignedCars`;
  }
  public static get updateCpAssignedCar(): string {
    return `CpAssignedCar`;
  }

  /* Assign User List 2019 */
  public static get listCpRnUser(): string {
    return `CpRnUsers`;
  }
  public static get updateCpRnUser(): string {
    return `CpRnUser`;
  }

  /* Car Request 2019 */
  public static get listCpCarRequest(): string {
    return `CpCarRequests`;
  }
  public static get updateCpCarRequest(): string {
    return `CpCarRequest`;
  }

  /* Car Maintenance 2019 */
  public static get listCpCarMaintenance(): string {
    return `CpCarMaintenances`;
  }
  public static get updateCpCarMaintenance(): string {
    return `CpCarMaintenance`;
  }

  /* House Master 2019 */
  public static get listCpHouseMaster(): string {
    return `CpHouseMasters`;
  }
  public static get updateCpHouseMaster(): string {
    return `CpHouseMaster`;
  }

  /* Assigned House Request 2019 */
  public static get listCpAssignedHome(): string {
    return `CpAssignedHomes`;
  }
  public static get updateCpAssignedHome(): string {
    return `CpAssignedHome`;
  }

  /* House Request 2019 */
  public static get listCpHouseRequest(): string {
    return `CpHouseRequests`;
  }
  public static get updateCpHouseRequest(): string {
    return `CpHouseRequest`;
  }

  /* House Relocation Request 2019 */
  public static get listCpHouseRelocation(): string {
    return `CpHouseRelocations`;
  }
  public static get updateCpHouseRelocation(): string {
    return `CpHouseRelocation`;
  }

  /*  Vendor Details 2019 */
  public static get listCpVendorDetail(): string {
    return `CpVendorDetails`;
  }
  public static get updateCpVendorDetail(): string {
    return `CpVendorDetail`;
  }

  /* Driver Master 2019 */
  public static get listCpDriverMaster(): string {
    return `CpDriverMasters`;
  }
  public static get updateCpDriverMaster(): string {
    return `CpDriverMaster`;
  }

  /* Driver Feedback 2019 */
  public static get listCpDriverFeedback(): string {
    return `CpDriverFeedbacks`;
  }
  public static get updateCpDriverFeedback(): string {
    return `CpDriverFeedback`;
  }

  /* Driver Concern 2019 */
  public static get listCpDriverConcern(): string {
    return `CpDriverConcerns`;
  }
  public static get updateCpDriverConcern(): string {
    return `CpDriverConcern`;
  }

  /* Driver Assigned 2019 */
  public static get listCpAssignedDriver(): string {
    return `CpAssignedDrivers`;
  }
  public static get updateCpAssignedDriver(): string {
    return `CpAssignedDriver`;
  }

  public static get listMiscData(): string {
    return `MiscData`;
  }
  public static get updateMiscData(): string {
    return `MiscData`;
  }

  public static get FuelMasterCard(): string {
    return `FuelCardMaster`;
  }

  public static get getMetaData(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.ScMetaData +
      `{
      ` +
      this.list +
      this.env +
      this.ScMetaData +
      ` {
        items{
          agency_types{
            type
            name
            contact
          }
        }
      }
    }`
    );
  }

  public static get ScUserTripItmes(): string {
    return `{
            nextToken
            items {
              id
              user_id
              trip_status
              trip_type
              otp
              is_boarded
              drop_point
              scheduled_date
              start_address{
                address
              }
              end_address{
                address
              }
            }
    }`;
  }

  public static get DaTripsItmes(): string {
    return `  items {
        created_at
        driver_id
        trip_id
        trip_status
        trip_type
        vehicle_no
        duty_start{
          address
          date_time
        }
        duty_end{
          address
          date_time
        }
        outstation_duty_start{
          address
          date_time
        }
        outstation_duty_end{

          address
          date_time
        }
        duty_start_device_id
        duty_start_device_details
        duty_end_device_id
        duty_end_device_details

    }`;
  }

  public static get RncUserItem(): string {
    return `{
      nextToken
  items{
    id
    name
    user_type
    profile_image
    user_name
    emergency_phone
    employee_phone
    sos_enabled
    home_address{
      address
    }
  }
}`;
  }

  public static get CreateAppFitnessFeedback(): string {
    return (
      `mutation ` +
      this.create +
      this.env +
      this.AppFitnessFeedback +
      `
     ($remarks: String,
      $rn_number: String,
      $rating: Int,
      $timestamp: String
 ) {
    ` +
      this.create +
      this.env +
      this.AppFitnessFeedback +
      `(input: {
      remarks: $remarks,
      rn_number: $rn_number,
      rating: $rating,
      timestamp: $timestamp

    }) {
        id
    }
  }`
    );
  }

  public static get CreateDaTrips(): string {
    return (
      `mutation ` +
      this.create +
      this.env +
      this.DaTrips +
      `($created_at: String,
      $driver_id: String,
      $trip_status: Int,
      $driver_id: String,
      $vehicle_no : String,
      $duty_start: PositionAddressInput,
      $duty_end: PositionAddressInput ) {
    ` +
      this.create +
      this.env +
      this.DaTrips +
      `(input: {
      created_at: $created_at,
      driver_id: $driver_id,
      trip_status: $trip_status,
      driver_id: $driver_id,
      vehicle_no :  $vehicle_no,
      duty_start: $duty_start,
      duty_end: $duty_end


    }) {
        trip_id
    }
  }`
    );
  }

  public static get CreateRnHrbotKeymapsSuggestions(): string {
    return `mutation createProdRnhrbotKeymapsSuggestions($context_key: String,
      $context_query_val: [String],
      $context_suggestions: [String],
      $policy_names : String
     ) {
      createProdRnhrbotKeymapsSuggestions(input: {
      context_key: $context_key,
      context_query_val: $context_query_val,
      context_suggestions: $context_suggestions,
      policy_names : $policy_names


    }) {
        id
    }
  }`;
  }

  public static get CreateScUserTrip(): string {
    return (
      `mutation ` +
      this.create +
      this.env +
      this.ScUserTrip +
      `($trip_id: String, $user_id: String, $trip_status: Int, $trip_type: Int, $otp: Int, $start_address : PositionMapInput, $end_address : PositionMapInput, $is_boarded: Boolean, $drop_point: Int,$scheduled_date : String ) {
    ` +
      this.create +
      this.env +
      this.ScUserTrip +
      `(input: {trip_id: $trip_id, user_id: $user_id, trip_status: $trip_status, trip_type: $trip_type, otp: $otp, start_address: $start_address, end_address: $end_address, is_boarded: $is_boarded, drop_point: $drop_point, scheduled_date: $scheduled_date}) {
        id
    }
  }`
    );
  }
  public static get UpdateScUserTripAddress(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.ScUserTrip +
      `($id: ID!, $start_address: PositionMapInput, $end_address: PositionMapInput) {
  ` +
      this.update +
      this.env +
      this.ScUserTrip +
      `(input: {id: $id, start_address: $start_address, end_address: $end_address}) {
        id
    }
  }`
    );
  }

  public static get UpdateScUserTrips(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.ScUserTrip +
      `($id: ID!,$trip_status: Int,$drop_point: Int,$otp: Int,$is_boarded: Boolean, $start_address: PositionMapInput, $end_address: PositionMapInput) {
    ` +
      this.update +
      this.env +
      this.ScUserTrip +
      `(input: {id: $id, trip_status: $trip_status,drop_point: $drop_point,otp: $otp,is_boarded: $is_boarded,start_address: $start_address, end_address: $end_address}) {
        id
    }
  }`
    );
  }

  public static get UpdateScUserTripsOtp(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.ScUserTrip +
      `($id: ID!$otp: Int) {
    ` +
      this.update +
      this.env +
      this.ScUserTrip +
      `(input: {id: $id, otp: $otp}) {
        id
    }
  }`
    );
  }

  public static get UpdateScUserByTrip(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.ScUserTrip +
      `($id: ID!,$trip_type: Int,$scheduled_date:String) {
    ` +
      this.update +
      this.env +
      this.ScUserTrip +
      `(input: {id: $id, trip_type: $trip_type,scheduled_date: $scheduled_date}) {
        id
    }
  }`
    );
  }

  public static get CreateScTripMaster(): string {
    return (
      `mutation ` +
      this.create +
      this.env +
      this.ScTripMaster +
      `( $driver_id: String, $cab_id: String, $scheduled_date: String, $trip_type: String,$status: Int , $start_otp : String, $end_otp : String) {
    ` +
      this.create +
      this.env +
      this.ScTripMaster +
      `(input: { driver_id: $driver_id, cab_id: $cab_id, scheduled_date: $scheduled_date, trip_type: $trip_type, status: $status, start_otp : $start_otp, end_otp : $end_otp}) {
        id
    }
  }`
    );
  }

  public static get CreateScCabMaster(): string {
    return (
      `mutation ` +
      this.create +
      this.env +
      this.ScCabMaster +
      `($driver_id: String!, $driver_name: String!, $vehicle_no: String!, $no_seats: Int!) {
    ` +
      this.create +
      this.env +
      this.ScCabMaster +
      `(input: {driver_id:$driver_id, driver_name: $driver_name, vehicle_no: $vehicle_no, no_seats: $no_seats}) {
        id
    }
  }`
    );
  }

  public static get UpdateScCabMasterSeats(): string {
    return (
      `mutation ` +
      this.create +
      this.env +
      this.ScCabMaster +
      `($id : ID!,$no_seats: Int!) {
  ` +
      this.create +
      this.env +
      this.ScCabMaster +
      `(input: {id : $id ,no_seats: $no_seats}) {
        id
    }
  }`
    );
  }

  public static get UpdateScSOS(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.ScSos +
      `($id: ID!,$comments: String,$status : Int) {
      ` +
      this.update +
      this.env +
      this.ScSos +
      `(input:{id: $id,comments: $comments,status: $status}) {
        id
        comments
        status
      }
    }`
    );
  }

  public static get UpdateScTripMaster(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.ScTripMaster +
      `($id: ID!,$driver_id: String,$cab_id: String,$scheduled_date : String,$status: Int,$trip_type: String) {
  ` +
      this.update +
      this.env +
      this.ScTripMaster +
      `(input:{id: $id,driver_id: $driver_id,cab_id: $cab_id,scheduled_date:$scheduled_date,status: $status,trip_type: $trip_type}) {
            id
          }
        }`
    );
  }

  public static get createDaVehicleMaster(): string {
    return (
      `mutation ` +
      this.create +
      this.env +
      this.DaVehicleMaster +
      `($vehicle_no: String!, $driver_id: String ,$geofence_limit: Int, $home_address: PositionMapInput, $office_address: PositionMapInput,$user_id: String, $user_name: String,$vehicle_model: String, $created_at:String,$updated_at: String,$status: Int,$user_phone_number: String,$notification_flag: Int,$agency_type: String, $driver_type: String) {
  ` +
      this.create +
      this.env +
      this.DaVehicleMaster +
      `(input:{vehicle_no: $vehicle_no, driver_id: $driver_id ,geofence_limit: $geofence_limit, home_address: $home_address, office_address: $office_address,user_id: $user_id, user_name: $user_name,vehicle_model: $vehicle_model, created_at: $created_at,updated_at: $updated_at,status: $status,user_phone_number: $user_phone_number,notification_flag: $notification_flag,agency_type: $agency_type, driver_type: $driver_type}) {
        id
    }
  }`
    );
  }
  public static get UpdateVehicleMaster(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.DaVehicleMaster +
      `($id:ID!,$vehicle_no: String!, $driver_id: String ,$geofence_limit: Int, $home_address: PositionMapInput, $office_address: PositionMapInput,$user_name: String,$vehicle_model: String,$updated_at: String,$status: Int,$user_phone_number: String,$notification_flag: Int,$agency_type: String, ,$driver_type: String) {
  ` +
      this.update +
      this.env +
      this.DaVehicleMaster +
      `(input:{id:$id,vehicle_no: $vehicle_no, driver_id: $driver_id ,geofence_limit: $geofence_limit, home_address: $home_address, office_address: $office_address, user_name: $user_name,vehicle_model: $vehicle_model,updated_at: $updated_at,status: $status,user_phone_number: $user_phone_number,notification_flag: $notification_flag, agency_type: $agency_type, driver_type: $driver_type}) {
        id
        agency_type
    }
  }`
    );
  }

  public static get UpdateVehicleMasterGeoFenceLimit(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.DaVehicleMaster +
      `($id:ID!,$office_address: PositionMapInput) {
  ` +
      this.update +
      this.env +
      this.DaVehicleMaster +
      `(input:{id:$id,office_address: $office_address}) {
        id
    }
  }`
    );
  }

  // update wellness app
  public static get updateWelnessDate(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.AppFitnessFeedback +
      `($id:ID!,$feedback_date: String,$feedback_month: String) {
  ` +
      this.update +
      this.env +
      this.AppFitnessFeedback +
      `(input:{id:$id,feedback_date: $feedback_date,feedback_month: $feedback_month}) {
        id
        feedback_date
    }
  }`
    );
  }

  public static get encrypt(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.DaVehicleMaster +
      `($id:ID!,$home_address: PositionMapInput,$office_address: PositionMapInput) {
  ` +
      this.update +
      this.env +
      this.DaVehicleMaster +
      `(input:{id:$id,home_address: $home_address,office_address: $office_address}) {
        id
    }
  }`
    );
  }

  //  public static get encrypt(): string {
  //    return `mutation ` + this.update + this.env + this.DaVehicleMaster + `($id:ID!,$user_phone_number: String) {
  //  `+ this.update + this.env + this.DaVehicleMaster + `(input:{id:$id,user_phone_number: $user_phone_number}) {
  //        id
  //    }
  //  }`
  //  }

  public static get rmapp(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.DaTrips +
      `($trip_id:ID!,$duty_start: PositionAddressInput,
    $duty_end: PositionAddressInput,
    $outstation_duty_start: PositionAddressInput,
    $outstation_duty_end: PositionAddressInput) {
` +
      this.update +
      this.env +
      this.DaTrips +
      `(input:{trip_id:$trip_id,
  duty_start: $duty_start,
  duty_end: $duty_end,
  outstation_duty_start: $outstation_duty_start,
  outstation_duty_end: $outstation_duty_end,

}) {
      trip_id
  }
}`
    );
  }

  public static get updateVehicleMstStatus(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.DaVehicleMaster +
      `($id: ID! ,$status : Int) {
    ` +
      this.update +
      this.env +
      this.DaVehicleMaster +
      `(input:{id: $id,status: $status}) {
      vehicle_no
    }
  }`
    );
  }

  public static get CreateRncUsers(): string {
    return (
      `mutation ` +
      this.create +
      this.env +
      this.RncUsers +
      `($user_type: Int, $name: String,$user_name: String, $password: String,$emergency_phone: String, $employee_phone: String,$sos_enabled: Int) {
  ` +
      this.create +
      this.env +
      this.RncUsers +
      `(input: {user_type: $user_type, name: $name, user_name: $user_name, password: $password, emergency_phone: $emergency_phone,employee_phone: $employee_phone,sos_enabled : $sos_enabled}) {
        id
      }
    }`
    );
  }

  public static get UpdateRncUsers(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.RncUsers +
      `($id: ID!,$home_address: PositionMapInput) {
  ` +
      this.update +
      this.env +
      this.RncUsers +
      `(input: {id: $id, home_address: $home_address}) {
            id
         }
        }`
    );
  }

  public static get UpdateRncUsersType(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.RncUsers +
      `($id: ID!,$user_type: Int) {
  ` +
      this.update +
      this.env +
      this.RncUsers +
      `(input: {id: $id, user_type: $user_type}) {
            id
         }
        }`
    );
  }

  /* 2019 rncuser */
  public static get updateRncUserAssignType(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.RncUsers +
      `($id: ID!, $user_type: Int) {
  ` +
      this.update +
      this.env +
      this.RncUsers +
      `(input: {id: $id, user_type: $user_type}) {
            id
            name
            user_name
            email_address
         }
        }`
    );
  }

  public static get UpdateRncUsersAgency(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.RncUsers +
      `($id: ID!,$agency_type: String) {
  ` +
      this.update +
      this.env +
      this.RncUsers +
      `(input: {id: $id, agency_type: $agency_type}) {
            id
         }
        }`
    );
  }

  public static get UpdateRncUsersData(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.RncUsers +
      `($id: ID!,$user_type: Int,,$sos_enabled: Int, $name: String,$user_name: String,$emergency_phone: String, $employee_phone: String) {
  ` +
      this.update +
      this.env +
      this.RncUsers +
      `(input: {id:$id,user_type: $user_type,sos_enabled: $sos_enabled, name: $name, user_name: $user_name,emergency_phone: $emergency_phone,employee_phone: $employee_phone}) {
        id
      }
    }`
    );
  }

  public static get UpdateRncUsersContact(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.RncUsers +
      `($id: ID!, $emergency_phone: String, $employee_phone: String) {
  ` +
      this.update +
      this.env +
      this.RncUsers +
      `(input: {id:$id,emergency_phone: $emergency_phone,employee_phone: $employee_phone}) {
        id
      }
    }`
    );
  }
  public static get DeleteScUserTrip(): string {
    return (
      `mutation ` +
      this.delete +
      this.env +
      this.ScUserTrip +
      `($id: ID!) {
      ` +
      this.delete +
      this.env +
      this.ScUserTrip +
      `(input:{id: $id}) {
      id
    }
  }`
    );
  }
  public static get DeleteScTripMaster(): string {
    return (
      `mutation ` +
      this.delete +
      this.env +
      this.ScTripMaster +
      `($id: ID!) {
  ` +
      this.delete +
      this.env +
      this.ScTripMaster +
      `(input:{id: $id}) {
      id
    }
  }`
    );
  }
  public static get DeleteDaVehicleMaster(): string {
    return (
      `mutation  ` +
      this.delete +
      this.env +
      this.DaVehicleMaster +
      `($id: String!) {
    ` +
      this.delete +
      this.env +
      this.DaVehicleMaster +
      `(input:{id: $id}) {
      id
    }
  }`
    );
  }

  /* List Da Vehicle Master Items */

  public static get listDaVehicleMastersItems(): string {
    return `
  {
    items {
     id
     driver_id
     user_id
     user_name
     vehicle_model
     vehicle_no
     geofence_limit
     notification_flag
     user_phone_number
     home_address {elat elong address lat long}
     office_address {elat elong address lat long}
     status
     agency_type
     driver_type
     driver {
        id
        agency_type
        employee_phone
        name
        user_name
        user_type
     }
  }
}`;
  }

  public static get ListDaVehicleMastersByUser(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listDaVehicleMasters +
      `($user_id : String){
      ` +
      this.list +
      this.env +
      this.listDaVehicleMasters +
      `(
        filter : {user_id : { eq: $user_id} }
      ) ` +
      this.listDaVehicleMastersItems +
      `
     }`
    );
  }
  public static get ListDaVehicleMastersByDriver(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listDaVehicleMasters +
      `($driver_id : String){
      ` +
      this.list +
      this.env +
      this.listDaVehicleMasters +
      `(
        filter : {driver_id : { eq: $driver_id} }
      ) {
        items {
         user_id
         user_name
        }
      }
     }`
    );
  }

  public static get ListDaVehicleMasters(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listDaVehicleMasters +
      `{
      ` +
      this.list +
      this.env +
      this.listDaVehicleMasters +
      this.listDaVehicleMastersItems +
      `
     }`
    );
  }

  public static get GetScTripPosition(): string {
    return (
      `query ` +
      this.getq +
      this.env +
      this.ScTripPosition +
      `($trip_id: String!) {
      ` +
      this.getq +
      this.env +
      this.ScTripPosition +
      `(trip_id: $trip_id) {
        position {
          lat
          long
        }
      }
    }`
    );
  }
  public static get ListRncUsers(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.RncUsers +
      ` {
      ` +
      this.list +
      this.env +
      this.RncUsers +
      ` (limit : 1000){
        nextToken
        items{
          id
          name
          user_type
          profile_image
          user_name
          emergency_phone
          employee_phone
          sos_enabled
          home_address{
            address
          }
        }
      }
    }`
    );
  }

  public static get GetRncUserLocationById(): string {
    return (
      `query ` +
      this.getq +
      this.env +
      this.RncUsers +
      `($id: ID!) {
      ` +
      this.getq +
      this.env +
      this.RncUsers +
      `(id: $id) {
        home_address {
          lat
          long
          address
        }
      }
    }`
    );
  }

  public static get findUserById(): string {
    return (
      `query   ` +
      this.list +
      this.env +
      this.RncUsers +
      `($id: ID!) {
      ` +
      this.list +
      this.env +
      this.RncUsers +
      `(filter:{
        id : { eq : $id}
      }
      ) {
        items{
          id
          name
          user_name
          user_type
        }
      }
    }`
    );
  }

  public static get findUserByUserName(): string {
    return (
      `query   ` +
      this.list +
      this.env +
      this.RncUsers +
      `($user_name: String) {
      ` +
      this.list +
      this.env +
      this.RncUsers +
      `(filter:{
        user_name : { eq : $user_name}
      }
      ) {
        items{
          id
          name
          user_name
          user_type
          email_address
        }
      }
    }`
    );
  }

  public static get LoginFindUser(): string {
    return (
      `query   ` +
      this.list +
      this.env +
      this.RncUsers +
      `($user_name: String) {
      ` +
      this.list +
      this.env +
      this.RncUsers +
      `(filter:{
        user_name : { eq : $user_name}
      }
      ) {
        items{
          id
          name
          user_type
          password
        }
      }
    }`
    );
  }

  public static get GetUsersByType(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.RncUsers +
      `($user_type: Int) {
      ` +
      this.list +
      this.env +
      this.RncUsers +
      `(filter:{
        user_type : { eq : $user_type}
      }
      ) {
        nextToken
        items{
          id
          name
          user_name
        }
      }
    }`
    );
  }

  public static get GetUsersByTypeByToken(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.RncUsers +
      `($user_type: Int , $nextToken:String) {
      ` +
      this.list +
      this.env +
      this.RncUsers +
      `(filter:{
        user_type : { eq : $user_type}
      }, nextToken :  $nextToken
      ) {
        nextToken
        items{
          id
          name
          user_name
        }
      }
    }`
    );
  }

  public static get GetDriverVehicle(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listDaVehicleMasters +
      `($driver_id: String) {
      ` +
      this.list +
      this.env +
      this.listDaVehicleMasters +
      `(filter:{
        driver_id : { eq : $driver_id}
      }
      ) {
        items{
          vehicle_no
          agency_type
        }
      }
    }`
    );
  }

  public static get GetScCabMaster(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listScCabMasters +
      `($driver_id: String, $vehicle_no : String ) {
      ` +
      this.list +
      this.env +
      this.listScCabMasters +
      `(filter:{
          driver_id :  { eq : $driver_id}
          vehicle_no : { eq : $vehicle_no}
        }
        ) {
          items{
            id
          }
        }
      }`
    );
  }
  public static get GetScCabMasterAll(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listScCabMasters +
      ` {
      ` +
      this.list +
      this.env +
      this.listScCabMasters +
      `{
          items{
            id
            vehicle_no
            driver_id
          }
        }
      }`
    );
  }
  public static get GetScCabMasterById(): string {
    return (
      `query  ` +
      this.getq +
      this.env +
      this.ScCabMaster +
      `($id: ID!) {
      ` +
      this.getq +
      this.env +
      this.ScCabMaster +
      `(id : $id ) {
            vehicle_no
        }
      }`
    );
  }

  // public static get GetScUserTriprById(): string {
  //   return `query  ` + this.getq + this.env + this.ScUserTrip + `($id: ID!) {
  //     `+ this.getq + this.env + this.ScUserTrip + `(id : $id ) {
  //           id
  //       }
  //     }`
  // }
  public static get GetScTripMaster(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `($driver_id: String,$cab_id: String, $trip_type : String,$scheduled_date : String ) {
      ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `(filter:{
      driver_id :  { eq : $driver_id}
      cab_id :  { eq : $cab_id}
      trip_type : { eq : $trip_type}
      scheduled_date : { eq : $scheduled_date}
        }
        ) {
          items{
            id
          }
        }
      }`
    );
  }
  public static get GetScTripMasterByID(): string {
    return (
      `query  ` +
      this.getq +
      this.env +
      this.ScTripMaster +
      `($id: ID! ) {
      ` +
      this.getq +
      this.env +
      this.ScTripMaster +
      `(id : $id) {
               id
              driver_id
              cab_id
              status
              trip_type
              scheduled_date
            }
          }`
    );
  }
  public static get getScSosListCnt(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listScSos +
      `{
      ` +
      this.list +
      this.env +
      this.listScSos +
      ` {
        items{
          id
        }
      }
    }`
    );
  }
  public static get getScSosList(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listScSos +
      `{
      ` +
      this.list +
      this.env +
      this.listScSos +
      ` {
        items{
          id
          trip_id
          user_id
          driver_id
          severity
          status
          position{
            address
          }
          created_at
          updated_at
          comments
        }
      }
    }`
    );
  }

  /* CAP 18-10-2019 */

  /* ####################### Assigned House ############ */

  public static get assignHomeFilter(): string {
    return (
      `query   ` +
      this.list +
      this.env +
      this.listCpAssignedHome +
      `($rn_id: String) {
      ` +
      this.list +
      this.env +
      this.listCpAssignedHome +
      `(filter:{
        rn_id : { eq : $rn_id}
        status : { eq : "ASSIGN"}
      }
      ) {
        items{
          id
          rn_id
        }
      }
    }`
    );
  }

  public static get rnUserFilter(): string {
    return (
      `query   ` +
      this.list +
      this.env +
      this.RncUsers +
      `($user_name: String) {
      ` +
      this.list +
      this.env +
      this.RncUsers +
      `(filter:{
        user_name : { eq : $user_name}
      }
      ) {
        items{
          id
          employee_phone
          name
          user_name
          user_type
          agency_type
          is_manager
          email_address
          reporting_manager
          is_active
        }
      }
    }`
    );
  }

  public static get homeIdFilter(): string {
    return (
      `query   ` +
      this.list +
      this.env +
      this.listCpHouseMaster +
      `($id: ID) {
      ` +
      this.list +
      this.env +
      this.listCpHouseMaster +
      `(filter:{
        id : { eq : $id}
      }
      ) {
        items{
          id
          house_address
          house_location
          house_city
          house_type
          house_size
          house_exdata
          owner_name
          owner_email
          owner_phone
          owner_address
          owner_exdata
          lease_start_date
          lease_end_date
          property_type
          created_date
          updated_date
        }
      }
    }`
    );
  }

  public static get CreateAssignHouse(): string {
    return (
      `mutation ` +
      this.create +
      this.env +
      this.updateCpAssignedHome +
      `(
      $user_pid: String,
      $rn_id: String,
      $home_id: String,
      $assigned_date: String,
      $status: String,
      $ex_data:String
      ) {
      ` +
      this.create +
      this.env +
      this.updateCpAssignedHome +
      `(input:{
      user_pid: $user_pid,
      rn_id: $rn_id,
      home_id: $home_id,
      assigned_date: $assigned_date,
      status: $status,
      ex_data: $ex_data
        }) {
        id
        status
        home_id
      }
    }`
    );
  }

  public static get getAssignHouseList(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listCpAssignedHome +
      `{
      ` +
      this.list +
      this.env +
      this.listCpAssignedHome +
      ` {
        items{
          id
          user_pid
          rn_id
          home_id
          assigned_date
          end_date
          status
          ex_data
        }
      }
    }`
    );
  }

  public static get updateAssignHouse(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.updateCpAssignedHome +
      `(
      $id: ID!,
      $rn_id: String,
      $home_id: String,
      $assigned_date: String,
      $end_date: String,
      $status: String
      ) {
      ` +
      this.update +
      this.env +
      this.updateCpAssignedHome +
      `(input:{
        id: $id,
        rn_id: $rn_id,
        home_id: $home_id,
        assigned_date: $assigned_date,
        end_date: $end_date,
        status: $status
        }) {
        id
        status
        home_id
      }
    }`
    );
  }

  public static get updateMasterHouse(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.updateCpHouseMaster +
      `(
      $id: ID!,
      $house_exdata: String
      ) {
      ` +
      this.update +
      this.env +
      this.updateCpHouseMaster +
      `(input:{
        id: $id,
        house_exdata: $house_exdata
        }) {
        id
        house_exdata
      }
    }`
    );
  }

  /* ####################### Assigned House ############ */

  /* A

  /* ####################### Assigned Car ##################### */
  //$nextToken:String,$limit:String,
  // nextToken:{ eq : $nextToken}
  // limit:{ eq : $limit}
  public static get filterRnCar(): string {
    return (
      `query   ` +
      this.list +
      this.env +
      this.listCpVehicleMaster +
      `($ex_data: String) {
      ` +
      this.list +
      this.env +
      this.listCpVehicleMaster +
      `(filter:{
        ex_data : { eq : $ex_data}
       
      }
      ) {
        items{
          id
          car_model
          veh_reg_id
          policy_no
          policy_from
          policy_to
          agency_name
          map_user_id
          lease_from
          lease_to
          car_type
          ex_data
        }
      }
    }`
    );
  }

  public static get filterRnExistCar(): string {
    return (
      `query   ` +
      this.list +
      this.env +
      this.listCpAssignedCar +
      `($rn_id: String) {
      ` +
      this.list +
      this.env +
      this.listCpAssignedCar +
      `(filter:{
        rn_id : { eq : $rn_id}
        status : { eq : "ASSIGN"}
      }
      ) {
        items{
          id
          rn_id
          car_id
          ex_data
          fuel_card_id
          status
        }
      }
    }`
    );
  }

  public static get getAssignCarList(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listCpAssignedCar +
      `{
      ` +
      this.list +
      this.env +
      this.listCpAssignedCar +
      ` {
        items{
          id
          user_pid
          rn_id
          car_id
          assigned_date
          end_date
          status
          ex_data
        }
      }
    }`
    );
  }

  public static get getCarListFilterAll(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listCpVehicleMaster +
      `{
      ` +
      this.list +
      this.env +
      this.listCpVehicleMaster +
      ` {
        items{
          id
          car_model
          veh_reg_id
          policy_no
          policy_from
          policy_to
          agency_name
          map_user_id
          lease_from
          lease_to
          car_type
          ex_data
        }
      }
    }`
    );
  }

  public static get CreateAssignCar(): string {
    return (
      `mutation ` +
      this.create +
      this.env +
      this.updateCpAssignedCar +
      `(
      $user_pid: String,
      $rn_id: String,
      $car_id: String,
      $assigned_date: String,
      $status: String,
      $ex_data:String,
      $fuel_card_id: String
      ) {
      ` +
      this.create +
      this.env +
      this.updateCpAssignedCar +
      `(input:{
      user_pid: $user_pid,
      rn_id: $rn_id,
      car_id: $car_id,
      assigned_date: $assigned_date,
      status: $status,
      ex_data: $ex_data
      fuel_card_id: $fuel_card_id
        }) {
        id
        status
        car_id,
        fuel_card_id
      }
    }`
    );
  }

  public static get updateAssignCar(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.updateCpAssignedCar +
      `(
      $id: ID!,
      $rn_id: String,
      $car_id: String,
      $assigned_date: String,
      $end_date: String,
      $status: String,
      $ex_data: String
      ) {
      ` +
      this.update +
      this.env +
      this.updateCpAssignedCar +
      `(input:{
        id: $id,
        rn_id: $rn_id,
        car_id: $car_id,
        assigned_date: $assigned_date,
        end_date: $end_date,
        status: $status,
        ex_data:$ex_data
        }) {
        id
        status
        car_id
        ex_data
      }
    }`
    );
  }

  public static get carIdFilter(): string {
    return (
      `query   ` +
      this.list +
      this.env +
      this.listCpVehicleMaster +
      `($id: ID) {
      ` +
      this.list +
      this.env +
      this.listCpVehicleMaster +
      `(filter:{
        id : { eq : $id}
      }
      ) {
        items{
          id
          car_model
          veh_reg_id
          policy_no
          policy_from
          policy_to
          agency_name
          map_user_id
          lease_from
          lease_to
          car_type
          ex_data

        }
      }
    }`
    );
  }

  public static get updateMasterCar(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.updateCpVehicleMaster +
      `(
      $id: ID!,
      $ex_data: String
      ) {
      ` +
      this.update +
      this.env +
      this.updateCpVehicleMaster +
      `(input:{
        id: $id,
        ex_data: $ex_data
        }) {
        id
        ex_data
      }
    }`
    );
  }

  /* ####################### Assigned Car ##################### */

  /* ####################### Assign user ###################### */
  public static get userAssignData(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.updateCpRnUser +
      `(
      $id: ID!,
      $user_name: String,
      $name: String,
      $email: String,
      $phone: String,
      $assign_mode: [String],
      $status: String,
      $ex_data: String,
      $updated_date: String
      ) {
      ` +
      this.update +
      this.env +
      this.updateCpRnUser +
      `(input:{
      id : $id,
      user_name: $user_name,
      name: $name,
      email: $email,
      phone: $phone,
      assign_mode: $assign_mode,
      status: $status,
      ex_data: $ex_data,
      updated_date: $updated_date
        }) {
        id
        name
        email
        user_name
        assign_mode
        ex_data
      }
    }`
    );
  }

  public static get CreateUserAssign(): string {
    return (
      `mutation ` +
      this.create +
      this.env +
      this.updateCpRnUser +
      `(
      $user_name: String,
      $name: String,
      $email: String,
      $phone: String,
      $assign_mode: [String],
      $status: String,
      $ex_data: String,
      $created_date: String,
      $updated_date: String
      ) {
      ` +
      this.create +
      this.env +
      this.updateCpRnUser +
      `(input:{
        user_name: $user_name,
        name: $name,
        email: $email,
        phone: $phone,
        assign_mode: $assign_mode,
        status: $status,
        ex_data: $ex_data,
        created_date: $created_date,
        updated_date: $updated_date
        }) {
        id
        user_name
        name
        email
        assign_mode
        ex_data
      }
    }`
    );
  }

  public static get filterRnUserExist(): string {
    return (
      `query   ` +
      this.list +
      this.env +
      this.listCpRnUser +
      `($user_name: String) {
      ` +
      this.list +
      this.env +
      this.listCpRnUser +
      `(filter:{
        user_name : { eq : $user_name}
      }
      ) {
        items{
          id
          user_name
        }
      }
    }`
    );
  }

  public static get getAssignUserList(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listCpRnUser +
      `{
      ` +
      this.list +
      this.env +
      this.listCpRnUser +
      ` {
        items{
        id
        user_name
        name
        email
        phone
        assign_mode
        status
        ex_data
        created_date
        updated_date
        }
      }
    }`
    );
  }

  /* ####################### Assign user ###################### */

  public static get getCarRequestListAll(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listCpCarRequest +
      `{
      ` +
      this.list +
      this.env +
      this.listCpCarRequest +
      ` {
        items{
          id
          username
          user_display_name
          veh_reg_no
          request_status
          car_status
          car_id
          comments{
            date
            des
            status
            exdata
          }
          ex_data
          request_id
          date
          feedback
          satisfaction
        }
      }
    }`
    );
  }

  public static get UpdateCarRequestData(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.updateCpCarRequest +
      `(
      $id: ID!,
      $car_id: String,
      $comments: [CommentsMapInput],
      $request_status: String,
      $car_status: String
      ) {
      ` +
      this.update +
      this.env +
      this.updateCpCarRequest +
      `(input:{
        id: $id,
        car_id: $car_id,
        comments: $comments,
        request_status: $request_status,
        car_status: $car_status
        }) {
        id
        car_id
      }
    }`
    );
  }

  // FILTER REQUEST
  public static get filterCarRecord(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listCpVehicleMaster +
      `($id: ID!){
      ` +
      this.list +
      this.env +
      this.listCpVehicleMaster +
      `(filter:{
        id: { eq: $id }
        }) {
        items{
          id
          car_model
          veh_reg_id
          policy_no
          policy_from
          policy_to
          agency_name
          map_user_id
        }
      }
    }`
    );
  }

  public static get getCarfilterList(): string {
    // Not Equal = ne, Equal = eq
    return (
      `query  ` +
      this.list +
      this.env +
      this.listCpVehicleMaster +
      `{
      ` +
      this.list +
      this.env +
      this.listCpVehicleMaster +
      `(filter:{
        map_user_id: { eq: "0" }
        }) {
        items{
          id
          car_model
          veh_reg_id
          policy_no
          policy_from
          policy_to
          agency_name
          map_user_id
        }
      }
    }`
    );
  }

  // userID inserted in car table
  public static get UpdateUserIdCarMaster(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.updateCpVehicleMaster +
      `(
      $id: ID!,
      $map_user_id: String
      ) {
      ` +
      this.update +
      this.env +
      this.updateCpVehicleMaster +
      `(input:{
        id: $id,
        map_user_id: $map_user_id
        }) {
        id
      }
    }`
    );
  }
  /* ################# CAR MODULE ################# */
  public static get getCarListAll(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listCpVehicleMaster +
      `{
      ` +
      this.list +
      this.env +
      this.listCpVehicleMaster +
      ` {
        items{
          id
          car_model
          veh_reg_id
          policy_no
          policy_from
          policy_to
          agency_name
          agency {
            id
            name
            email
            phone
            address
            vendor_type
            is_active
            ex_data
            created_date
            updated_date
          }
          map_user_id
          lease_from
          lease_to
          car_type
          ex_data
        }
      }
    }`
    );
  }

  public static get UpdateCarData(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.updateCpVehicleMaster +
      `(
      $id: ID!,
      $car_model: String,
      $veh_reg_id: String,
      $policy_no: String,
      $policy_from: String,
      $policy_to: String,
      $agency_name: String,
      $map_user_id: String,
      $lease_from: String,
      $lease_to: String
      ) {
      ` +
      this.update +
      this.env +
      this.updateCpVehicleMaster +
      `(input:{
        id: $id,
        car_model: $car_model,
        veh_reg_id: $veh_reg_id,
        policy_no: $policy_no,
        policy_from: $policy_from,
        policy_to: $policy_to,
        agency_name: $agency_name,
        map_user_id: $map_user_id,
        lease_from: $lease_from,
        lease_to: $lease_to
        }) {
        id
      }
    }`
    );
  }
  public static get CreateCarData(): string {
    return (
      `mutation ` +
      this.create +
      this.env +
      this.updateCpVehicleMaster +
      `(
      $car_model: String,
      $veh_reg_id: String,
      $policy_no: String,
      $policy_from: String,
      $policy_to: String,
      $agency_name: String,
      $map_user_id: String,
      $lease_from: String,
      $lease_to: String,
      $car_type: String,
      $ex_data: String
      ) {
      ` +
      this.create +
      this.env +
      this.updateCpVehicleMaster +
      `(input:{
        car_model: $car_model,
        veh_reg_id: $veh_reg_id,
        policy_no: $policy_no,
        policy_from: $policy_from,
        policy_to: $policy_to,
        agency_name: $agency_name,
        map_user_id: $map_user_id
        lease_from: $lease_from,
        lease_to: $lease_to,
        car_type: $car_type,
        ex_data: $ex_data
        }) {
        id
      }
    }`
    );
  }

  public static get deleteCarData(): string {
    return (
      `mutation ` +
      this.delete +
      this.env +
      this.updateCpVehicleMaster +
      `($id: ID!) {
      ` +
      this.delete +
      this.env +
      this.updateCpVehicleMaster +
      `(input:{id: $id}) {
      id
    }
  }`
    );
  }

  /* CAP 18-10-2019 */

  /* ########## HOUSE REQUEST MODULE 2019 ############ */

  public static get getHouseRequestListAll(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listCpHouseRequest +
      `{
      ` +
      this.list +
      this.env +
      this.listCpHouseRequest +
      ` {
        items{
          id
          username
          user_display_name
          vendor_details{
            name
            email
            mobile
          }
          house_id
          house_address
          request_status
          request_id
          user_request
          user_text
          comments{
            date
            des
            status
            exdata
          }
          req_date
          ex_data
          sla_date
          created_date
          updated_date
          feedback
          satisfaction
          created_type
          rncuser_id
          ticket_id
        }
      }
    }`
    );
  }

  public static get UpdateHouseRequestData(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.updateCpHouseRequest +
      `(
      $id: ID!,
      $comments: [HouseCommentsMapInput],
      $request_status: String,
      $ex_data: String,
      $sla_date: String
      ) {
      ` +
      this.update +
      this.env +
      this.updateCpHouseRequest +
      `(input:{
        id: $id,
        comments: $comments,
        request_status: $request_status,
        ex_data: $ex_data,
        sla_date: $sla_date
        }) {
          id
          username
          user_display_name
          house_address
          house_id
          request_status
          request_id
          user_request
          user_text
          comments
          {
            date
            des
            status
            exdata
          }
          req_date
          sla_date
          ex_data
          created_date
          updated_date
          feedback
          satisfaction
      }
    }`
    );
  }
  /* ########## HOUSE REQUEST MODULE 2019 ############ */

  /* ########## HOUSE RELOCATION REQUEST MODULE 2019 ############ */
  public static get getHouseReLocationListAll(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listCpHouseRelocation +
      `{
      ` +
      this.list +
      this.env +
      this.listCpHouseRelocation +
      ` {
        items{
          id
          username
          user_display_name
          house_id
          house_address
          request_status
          request_id
          comments{
            date
            des
            status
            exdata
          }
          req_date
          req__comp_status
          feedback
          satisfaction
          vendor_details{
            id
            date
            vendor_id
            ex_data
          }
          new_address
          expected_date
          time_slot{
            date
            ex_data
          }
          packing_Date{
            id
            date
            vendor_id
            ex_data
          }
          ex_data
          sla_date
          created_date
          updated_date
          created_type
          rncuser_id
          ticket_id

        }
      }
    }`
    );
  }

  public static get UpdateReHouseRequestData(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.updateCpHouseRelocation +
      `(
      $id: ID!,
      $comments: [HouseCommentsMapInput],
      $request_status: String,
      $ex_data: String,
      $sla_date: String,
      $packing_Date: [VendorInfoInput]
      ) {
      ` +
      this.update +
      this.env +
      this.updateCpHouseRelocation +
      `(input:{
        id: $id,
        comments: $comments,
        request_status: $request_status,
        ex_data: $ex_data,
        sla_date: $sla_date,
        packing_Date: $packing_Date
        }) {
          id
          username
          user_display_name
          house_address
          house_id
          request_status
          request_id
          comments
          {
            date
            des
            status
            exdata
          }
          req_date
          ex_data
          sla_date
          created_date
          updated_date
          feedback
          satisfaction
      }
    }`
    );
  }

  public static get vendorIdFilter(): string {
    return (
      `query   ` +
      this.list +
      this.env +
      this.listCpVendorDetail +
      `($id: ID) {
      ` +
      this.list +
      this.env +
      this.listCpVendorDetail +
      `(filter:{
        id : { eq : $id}
      }
      ) {
        items{
          id
          name
          email
          phone
          address
          vendor_type
          is_active
          ex_data
          created_date
          updated_date
        }
      }
    }`
    );
  }

  public static get userHouseFilter(): string {
    return (
      `query   ` +
      this.list +
      this.env +
      this.listCpHouseMaster +
      `($id: ID) {
      ` +
      this.list +
      this.env +
      this.listCpHouseMaster +
      `(filter:{
        id : { eq : $id}
      }
      ) {
        items{
          id
          house_address
          house_location
          house_city
          house_type
          house_size
          house_exdata
          owner_name
          owner_email
          owner_phone
          owner_address
          owner_exdata
          lease_start_date
          lease_end_date
          property_type
          created_date
          updated_date
        }
      }
    }`
    );
  }

  public static get singleHouseData(): string {
    return (
      `query   ` +
      this.list +
      this.env +
      this.listCpHouseRequest +
      `($id: ID) {
      ` +
      this.list +
      this.env +
      this.listCpHouseRequest +
      `(filter:{
        id : { eq : $id}
      }
      ) {
        items{
          id
          username
          house_id
          request_status
          request_id
          user_request
          user_text
          comments{
            date
            des
            status
            exdata
          }
          req_date
          ex_data
          created_date
          updated_date
          feedback
          satisfaction
        }
      }
    }`
    );
  }

  public static get singleHouseRelocationData(): string {
    return (
      `query   ` +
      this.list +
      this.env +
      this.listCpHouseRelocation +
      `($id: ID) {
      ` +
      this.list +
      this.env +
      this.listCpHouseRelocation +
      `(filter:{
        id : { eq : $id}
      }
      ) {
        items{
          id
          username
          house_id
          request_status
          request_id
          comments{
            date
            des
            status
            exdata
          }
          req_date
          req__comp_status
          feedback
          satisfaction
          vendor_details{
            id
            date
            vendor_id
            ex_data
          }
          new_address
          expected_date
          time_slot{
            date
            ex_data
          }
          packing_Date{
            id
            date
            vendor_id
            ex_data
          }
          ex_data
          created_date
          updated_date
        }
      }
    }`
    );
  }
  /* ########## HOUSE RELOCATION REQUEST MODULE 2019 ############ */

  /* ########## CAR MAINTENANCE REQUEST MODULE 2019 ############ */

  public static get singleCarData(): string {
    return (
      `query   ` +
      this.list +
      this.env +
      this.listCpCarMaintenance +
      `($id: ID) {
      ` +
      this.list +
      this.env +
      this.listCpCarMaintenance +
      `(filter:{
        id : { eq : $id}
      }
      ) {
        items{
          id
          username
          car_id
          request_status
          request_id
          user_request
          user_text
          comments{
            date
            des
            status
            exdata
          }
          req_date
          ex_data
          created_date
          updated_date
          feedback
          satisfaction
        }
      }
    }`
    );
  }
  //($limit: Int!,$nextToken:String)
  // (limit: $limit,nextToken: $nextToken,
  // )
  public static get getCarMaintenanceNextTokenListAll(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listCpCarMaintenance +
      `($nextToken: String, $limit: Int) {
        ` +
      this.list +
      this.env +
      this.listCpCarMaintenance +
      `(
          nextToken: $nextToken
          limit: $limit
        ) {
          items{
            id
            username
            user_display_name
            veh_reg_no
            car_id
            request_status
            request_id
            user_request
            user_text
            comments{
              date
              des
              status
              exdata
            }
            req_date
            ex_data
            sla_date
            created_date
            updated_date
            feedback
            satisfaction
            odometer
          }
          nextToken
        }
      }`
    );
  }

  public static get getCarMaintenanceListAll(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listCpCarMaintenance +
      `{
      ` +
      this.list +
      this.env +
      this.listCpCarMaintenance +
      ` {

        items{
          id
          username
          user_display_name
          veh_reg_no
          car_id
          request_status
          request_id
          user_request
          user_text
          comments{
            date
            des
            status
            exdata
          }
          req_date
          ex_data
          sla_date
          created_date
          updated_date
          feedback
          satisfaction
          odometer
        }
        nextToken
      }
    }`
    );
  }
  /*  created_type
  rncuser_id
  ticket_id */

  public static get UpdateCarMaintenanceData(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.updateCpCarMaintenance +
      `(
      $id: ID!,
      $comments: [HouseCommentsMapInput],
      $request_status: String,
      $updated_date:String,
      $ex_data: String,
      $sla_date: String
      ) {
      ` +
      this.update +
      this.env +
      this.updateCpCarMaintenance +
      `(input:{
        id: $id,
        comments: $comments,
        request_status: $request_status,
        updated_date: $updated_date,
        ex_data: $ex_data,
        sla_date: $sla_date
        }) {
          id
          username
          user_display_name
          veh_reg_no
          car_id
          request_status
          request_id
          user_request
          user_text
          comments
          {
            date
            des
            status
            exdata
          }
          req_date
          ex_data
          sla_date
          created_date
          updated_date
          feedback
          satisfaction
          username
          created_type
          rncuser_id
      }
    }`
    );
  }
  /* ########## CAR MAINTENANCE MODULE 2019 ############ */

  /* ########## HOUSE MODULE 2019 ############ */

  public static get getUnAssignHouseList(): string {
    return (
      `query   ` +
      this.list +
      this.env +
      this.listCpHouseMaster +
      `($house_exdata: String) {
      ` +
      this.list +
      this.env +
      this.listCpHouseMaster +
      `(filter:{
        house_exdata : { eq : $house_exdata}
      }
      ) {
        items{
         id
          house_address
          house_location
          house_city
          house_type
          house_size
          house_exdata
          owner_name
          owner_email
          owner_phone
          owner_address
          owner_exdata
          lease_start_date
          lease_end_date
          property_type
          created_date
          updated_date
        }
      }
    }`
    );
  }

  public static get getHouseList(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listCpHouseMaster +
      `{
      ` +
      this.list +
      this.env +
      this.listCpHouseMaster +
      ` {
        items{
          id
          house_address
          house_location
          house_city
          house_type
          house_size
          house_exdata
          owner_name
          owner_email
          owner_phone
          owner_address
          owner_exdata
          lease_start_date
          lease_end_date
          property_type
          created_date
          updated_date
        }
      }
    }`
    );
  }

  public static get CreateHouseData(): string {
    return (
      `mutation ` +
      this.create +
      this.env +
      this.updateCpHouseMaster +
      `(
      $house_address: String,
      $house_location: String,
      $house_city: String,
      $house_type: String,
      $house_size: String,
      $house_exdata: String,
      $owner_name: String,
      $owner_email: String,
      $owner_phone: String,
      $owner_address: String,
      $owner_exdata: String,
      $lease_start_date: String,
      $lease_end_date: String,
      $property_type: String,
      $created_date: String,
      $updated_date: String
      ) {
      ` +
      this.create +
      this.env +
      this.updateCpHouseMaster +
      `(input:{
        house_address: $house_address
        house_location: $house_location
        house_city: $house_city
        house_type: $house_type
        house_size: $house_size
        house_exdata: $house_exdata
        owner_name: $owner_name
        owner_email: $owner_email
        owner_phone: $owner_phone
        owner_address: $owner_address
        owner_exdata: $owner_exdata
        lease_start_date:  $lease_start_date
        lease_end_date: $lease_end_date
        property_type: $property_type
        created_date: $created_date
        updated_date: $updated_date
        }) {
        id
      }
    }`
    );
  }

  public static get UpdateHouseData(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.updateCpHouseMaster +
      `(
      $id: ID!,
      $house_address: String,
      $house_location: String,
      $house_city: String,
      $house_type: String,
      $house_size: String,
      $owner_name: String,
      $owner_email: String,
      $owner_phone: String,
      $owner_address: String,
      $owner_exdata: String,
      $lease_start_date: String,
      $lease_end_date: String,
      $property_type: String,
      $updated_date: String
      ) {
      ` +
      this.update +
      this.env +
      this.updateCpHouseMaster +
      `(input:{
        id: $id,
        house_address: $house_address
        house_location: $house_location
        house_city: $house_city
        house_type: $house_type
        house_size: $house_size
        owner_name: $owner_name
        owner_email: $owner_email
        owner_phone: $owner_phone
        owner_address: $owner_address
        owner_exdata: $owner_exdata
        lease_start_date:  $lease_start_date
        lease_end_date: $lease_end_date
        property_type: $property_type
        updated_date: $updated_date
        }) {
        id
      }
    }`
    );
  }

  public static get deleteHouseData(): string {
    return (
      `mutation ` +
      this.delete +
      this.env +
      this.updateCpHouseMaster +
      `($id: ID!) {
      ` +
      this.delete +
      this.env +
      this.updateCpHouseMaster +
      `(input:{id: $id}) {
      id
    }
  }`
    );
  }
  /* ########## HOUSE MODULE 2019 ############ */

  /* ########## Driver MODULE 2019 ############ */
  public static get getDriverList(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listCpDriverMaster +
      `{
    ` +
      this.list +
      this.env +
      this.listCpDriverMaster +
      ` {
      items{
        id
        user_pid
        driver_name
        date_of_birth
        driving_license_no
        license_exp_date
        vendor_name
        is_active
        is_assigned
        ex_data
        created_date
        updated_date
      }
    }
  }`
    );
  }

  public static get getDriverListByPid(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listCpDriverMaster +
      `($user_pid : String){
    ` +
      this.list +
      this.env +
      this.listCpDriverMaster +
      `(
      filter:{
      user_pid: { eq: $user_pid }
      }) {
      items{
        id
        user_pid
        driver_name
        date_of_birth
        driving_license_no
        license_exp_date
        vendor_name
        is_active
        is_assigned
        ex_data
        created_date
        updated_date
      }
    }
  }`
    );
  }
  public static get CreateDriverData(): string {
    return (
      `mutation ` +
      this.create +
      this.env +
      this.updateCpDriverMaster +
      `(
    $user_pid: String
    $driver_name: String
    $date_of_birth: String
    $driving_license_no: String
    $license_exp_date: String
    $vendor_name: String
    $is_active: String
    $is_assigned: String
    $ex_data: String
    $created_date: String
    $updated_date: String
    ) {
    ` +
      this.create +
      this.env +
      this.updateCpDriverMaster +
      `(input:{
      user_pid: $user_pid
      driver_name: $driver_name
      date_of_birth: $date_of_birth
      driving_license_no: $driving_license_no
      license_exp_date: $license_exp_date
      vendor_name: $vendor_name
      is_active: $is_active
      is_assigned: $is_assigned
      ex_data: $ex_data
      created_date: $created_date
      updated_date: $updated_date
      }) {
      id
    }
  }`
    );
  }

  public static get UpdateDriverData(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.updateCpDriverMaster +
      `(
    $id: ID!,
    $user_pid: String
    $driver_name: String
    $date_of_birth: String
    $driving_license_no: String
    $license_exp_date: String
    $vendor_name: String
    $is_active: String
    $is_assigned: String
    $ex_data: String
    $created_date: String
    $updated_date: String
    ) {
    ` +
      this.update +
      this.env +
      this.updateCpDriverMaster +
      `(input:{
      id: $id,
      user_pid: $user_pid
      driver_name: $driver_name
      date_of_birth: $date_of_birth
      driving_license_no: $driving_license_no
      license_exp_date: $license_exp_date
      vendor_name: $vendor_name
      is_active: $is_active
      is_assigned: $is_assigned
      ex_data: $ex_data
      created_date: $created_date
      updated_date: $updated_date
      }) {
      id
    }
  }`
    );
  }

  public static get deleteDriverData(): string {
    return (
      `mutation ` +
      this.delete +
      this.env +
      this.updateCpDriverMaster +
      `($id: ID!) {
    ` +
      this.delete +
      this.env +
      this.updateCpDriverMaster +
      `(input:{id: $id}) {
    id
  }
}`
    );
  }

  public static get getDriverFeedbackList(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listCpDriverFeedback +
      `{
    ` +
      this.list +
      this.env +
      this.listCpDriverFeedback +
      ` {
      items{
        id
        username
        driver_id
        user_display_name
        driver_username
        driver_display_name
        questions_rating{
          ques_name
          rating
        }
        comments
        ex_data
        created_date
        updated_date
      }
    }
  }`
    );
  }

  public static get UpdateDriverFeedbackData(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.updateCpDriverFeedback +
      `(
    $id: ID!,
    $ex_data: String
    $updated_date: String
    ) {
    ` +
      this.update +
      this.env +
      this.updateCpDriverFeedback +
      `(input:{
      id: $id,
      ex_data: $ex_data,
      updated_date:$updated_date
      }) {
      id
    }
  }`
    );
  }

  public static get getDriverConcernList(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listCpDriverConcern +
      `{
    ` +
      this.list +
      this.env +
      this.listCpDriverConcern +
      ` {
      items{
        id
         driver_id
         username
         user_pid
         user_display_name
         driver_username
         driver_display_name
         concern_type
         user_text
         sla_date
         ex_data
         created_date
         updated_date
         request_status
         request_id
         comments {
          date
          des
          status
          exdata
          }
         req_date
         feedback
         satisfaction
         created_type,
         ticket_id,
         rncuser_id,

      }
    }
  }`
    );
  }

  public static get UpdateDriverConcernData(): string {
    return (
      //$ex_data: String,
      //ex_data: $ex_data,
      `mutation ` +
      this.update +
      this.env +
      this.updateCpDriverConcern +
      `(
        $id: ID!,
        $comments: [HouseCommentsMapInput],
        $request_status: String,
        $sla_date: String,
        $updated_date:String
    ) {
    ` +
      this.update +
      this.env +
      this.updateCpDriverConcern +
      `(input:{
        id: $id,
        comments: $comments,
        request_status: $request_status,
        sla_date: $sla_date,
        updated_date:$updated_date
      }) {
        id
        driver_id
        user_pid
        user_display_name
        driver_username
        driver_display_name
        username
        request_status
        sla_date
        request_id
        concern_type
        user_text
        comments
        {
          date
          des
          status
          exdata
        }
        ex_data
        created_date
        updated_date
        feedback
        satisfaction
    }
  }`
    );
  }

  public static get getAssignedDriver(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listCpAssignedDriver +
      `{
    ` +
      this.list +
      this.env +
      this.listCpAssignedDriver +
      ` {
      items{
        id
        assigned_date
        end_date
        driver_id
        username
        user_pid
        status
        ex_data
        created_date
        updated_date
      }
    }
  }`
    );
  }

  public static get CreateDriverAssignData(): string {
    return (
      `mutation ` +
      this.create +
      this.env +
      this.updateCpAssignedDriver +
      `(
    $assigned_date: String
    $end_date: String
    $driver_id: String
    $username: String
    $user_pid: String
    $status: String
    $ex_data: String
    $created_date: String
    $updated_date: String
    ) {
    ` +
      this.create +
      this.env +
      this.updateCpAssignedDriver +
      `(input:{
      assigned_date: $assigned_date
      end_date: $end_date
      driver_id: $driver_id
      username: $username
      user_pid: $user_pid
      status: $status
      ex_data: $ex_data
      created_date: $created_date
      updated_date: $updated_date
      }) {
      id
    }
  }`
    );
  }

  public static get UpdateDriverAssignData(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.updateCpAssignedDriver +
      `(
    $id: ID!,
    $assigned_date: String
    $end_date: String
    $driver_id: String
    $username: String
    $user_pid: String
    $status: String
    $ex_data: String
    $created_date: String
    $updated_date: String
    ) {
    ` +
      this.update +
      this.env +
      this.updateCpAssignedDriver +
      `(input:{
      id: $id,
      assigned_date: $assigned_date
      end_date: $end_date
      driver_id: $driver_id
      username: $username
      user_pid: $user_pid
      status: $status
      ex_data: $ex_data
      created_date: $created_date
      updated_date: $updated_date
      }) {
      id
    }
  }`
    );
  }
  public static get rnUserFilterbyId(): string {
    return (
      `query   ` +
      this.getq +
      this.env +
      this.RncUsers +
      `($id: ID!) {
    ` +
      this.getq +
      this.env +
      this.RncUsers +
      `(
      id : $id
    ) {
        id
        employee_phone
        name
        user_name
        user_type
        agency_type
        is_manager
        email_address
        reporting_manager
        is_active
    }
  }`
    );
  }

  /* ########## Driver MODULE 2019 ############ */
  /* ########## VENDOR MODULE 2019 ############ */
  public static get getVendorlist(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listCpVendorDetail +
      `{
      ` +
      this.list +
      this.env +
      this.listCpVendorDetail +
      ` {
        items{
          id
          name
          email
          phone
          address
          vendor_type
          is_active
          ex_data
          created_date
          updated_date
        }
      }
    }`
    );
  }

  public static get getActiveVendorlist(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listCpVendorDetail +
      `{
      ` +
      this.list +
      this.env +
      this.listCpVendorDetail +
      `(filter :{
        is_active      :{eq : "Active"}
      })  {
        items{
          id
          name
          email
          phone
          address
          vendor_type
          is_active
          ex_data
          created_date
          updated_date
        }
      }
    }`
    );
  }

  public static get CreateVendorData(): string {
    return (
      `mutation ` +
      this.create +
      this.env +
      this.updateCpVendorDetail +
      `(
      $name: String
      $email: String
      $phone: String
      $address: String
      $vendor_type: String
      $is_active: String
      $ex_data: String
      $created_date: String
      $updated_date: String
      ) {
      ` +
      this.create +
      this.env +
      this.updateCpVendorDetail +
      `(input:{
        name: $name
        email: $email
        phone: $phone
        address: $address
        vendor_type: $vendor_type
        is_active: $is_active
        ex_data: $ex_data
        created_date: $created_date
        updated_date: $updated_date
        }) {
        id
      }
    }`
    );
  }

  public static get UpdateVendorData(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.updateCpVendorDetail +
      `(
      $id: ID!
      $name: String
      $email: String
      $phone: String
      $address: String
      $vendor_type: String
      $is_active: String
      $updated_date: String
      $ex_data: String
      ) {
      ` +
      this.update +
      this.env +
      this.updateCpVendorDetail +
      `(input:{
        id: $id
        name: $name
        email: $email
        phone: $phone
        address: $address
        vendor_type: $vendor_type
        is_active: $is_active
        ex_data: $ex_data
        updated_date: $updated_date
        }) {
        id
      }
    }`
    );
  }

  public static get deleteVendorData(): string {
    return (
      `mutation ` +
      this.delete +
      this.env +
      this.updateCpVendorDetail +
      `($id: ID!) {
      ` +
      this.delete +
      this.env +
      this.updateCpVendorDetail +
      `(input:{id: $id}) {
      id
    }
  }`
    );
  }

  /* ########## VENDOR MODULE 2019 ############ */

  public static get getAppFitnessFeedback(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listAppFitnessFeedback +
      `($in_time: String,$to_date: String ){
      ` +
      this.list +
      this.env +
      this.listAppFitnessFeedback +
      `(
        filter : {

        feedback_date : {
          ge : $in_time,
          le : $to_date
        }

    } ) {
        nextToken
        items{
          id
          remarks
          rn_number
          rating
          timestamp
          feedback_date
          feedback_month
        }
      }
    }`
    );
  }

  public static get getAppFitnessFeedbackMigration(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listAppFitnessFeedback +
      `{
      ` +
      this.list +
      this.env +
      this.listAppFitnessFeedback +
      ` {
        nextToken
        items{
          id
          remarks
          rn_number
          rating
          timestamp
          feedback_date
          feedback_month
        }
      }
    }`
    );
  }

  public static get getAppFitnessFeedbackNextTokenMigration(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listAppFitnessFeedback +
      `($nextToken: String){
      ` +
      this.list +
      this.env +
      this.listAppFitnessFeedback +
      ` (nextToken: $nextToken ){
        nextToken
        items{
          id
          remarks
          rn_number
          feedback_date
          feedback_month
          rating
          timestamp
        }
      }
    }`
    );
  }

  public static get getAppFitnessFeedbackNextToken(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listAppFitnessFeedback +
      `($nextToken: String,$in_time: String,$to_date: String ){
      ` +
      this.list +
      this.env +
      this.listAppFitnessFeedback +
      ` (nextToken: $nextToken,
        filter : {

          feedback_date : {
            ge : $in_time,
            le : $to_date
          }

      } ){
        nextToken
        items{
          id
          remarks
          rn_number
          feedback_date
          feedback_month
          rating
          timestamp
        }
      }
    }`
    );
  }

  public static get getOpenSos(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listScSos +
      `{
      ` +
      this.list +
      this.env +
      this.listScSos +
      `(filter :{
        status      :{eq : 0}
      })  {
        items{
          id
          trip_id
          user_id
          driver_id
          severity
          status
          position{
            address
          }
          created_at
          updated_at
          comments
        }
      }
    }`
    );
  }
  public static get getScSosMaster(): string {
    return (
      `query   ` +
      this.list +
      this.env +
      this.listScSosMasters +
      `{
      ` +
      this.list +
      this.env +
      this.listScSosMasters +
      ` {
        items{
          id
          sos_name
          email
          contacts
        }
      }
    }`
    );
  }

  public static get getCompletedTrip(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `($status: Int, $lecondition:String,$gecondition:String) {
      ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `(filter :{
        status      :{eq : $status}
        scheduled_date :{le : $lecondition
          ge : $gecondition}
      }) {
        items {
          id
          driver_id
          trip_type
          scheduled_date
          cab_id
        }
      }
    }`
    );
  }

  public static get getCompletedTripNextToken(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `($status: Int, $lecondition:String,$gecondition:String,$nextToken:String) {
      ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `(filter :{
        status      :{eq : $status}
        scheduled_date :{le : $lecondition
          ge : $gecondition}
      },nextToken:$nextToken) {
        items {
          id
          driver_id
          trip_type
          scheduled_date
          cab_id
        }
        nextToken
      }
    }`
    );
  }
  public static get getCompletedTripCnt(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `($status: Int, $scheduled_date:String) {
      ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `(filter :{
        status      :{eq : $status}
        scheduled_date :{le : $scheduled_date}
      }) {
        items {


          trip_type

        }
      }
    }`
    );
  }
  public static get getRemainingTrip(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `($status: Int, $lecondition:String,$gecondition:String) {
      ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `(filter :{
        status      :{eq : $status}
        scheduled_date :{le : $lecondition
                         ge : $gecondition}
      }
    ) {
        items {
          id
          driver_id
          trip_type
          scheduled_date
          cab_id
        }
      }
    }`
    );
  }

  public static get getRemainingTripNextToken(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `($status: Int, $lecondition:String,$gecondition:String,$nextToken:String) {
      ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `(filter :{
        status      :{eq : $status}
        scheduled_date :{le : $lecondition
                         ge : $gecondition}
      },nextToken:$nextToken
    ) {
        items {
          id
          driver_id
          trip_type
          scheduled_date
          cab_id
        }
        nextToken
      }
    }`
    );
  }

  public static get getRemainingTripCnt(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `($status: Int, $scheduled_date:String) {
      ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `(filter :{
        status      :{eq : $status}
        scheduled_date :{ge : $scheduled_date}
      }
    ) {
        items {

          trip_type

        }
      }
    }`
    );
  }
  public static get GetCurrentDayTrip(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `($today : String) {
      ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `(filter :{
        scheduled_date : {
          contains : $today
        }
      }) {
        items {
          id
          driver_id
          status
          trip_type
          scheduled_date
        }
      }
    }`
    );
  }

  public static get GetCurrentDayTripNextToken(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `($today : String,$nextToken:String) {
      ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `(filter :{
        scheduled_date : {
          contains : $today
        }
      },nextToken:$nextToken) {
        items {
          id
          driver_id
          status
          trip_type
          scheduled_date
        }
        nextToken
      }
    }`
    );
  }

  public static get ListScTripMaster(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listScTripMasters +
      ` {
      ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `{
               items{
                id
                driver_id
                cab_id
                status
                trip_type
                scheduled_date
              }
        nextToken
              }
            }`
    );
  }
  public static get ListScTripMasterNextToken(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `($nextToken:String) {
      ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `(nextToken:$nextToken){
               items{
                id
                driver_id
                cab_id
                status
                trip_type
                scheduled_date
              }
        nextToken
              }
            }`
    );
  }

  public static get ListScTripMasterBySchdule(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `($scheduled_date:String) {
      ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `(
        filter : {
          scheduled_date : {contains : $scheduled_date}
        }
              ) {
               items{
                id
                driver_id
                cab_id
                status
                trip_type
                scheduled_date
              }
        nextToken
              }
            }`
    );
  }

  public static get ListScTripMasterBySchduleNextToken(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `($scheduled_date:String,$nextToken:String) {
      ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `(
        filter : {
          scheduled_date : {contains : $scheduled_date}
        },nextToken:$nextToken
              ) {
               items{
                id
                driver_id
                cab_id
                status
                trip_type
                scheduled_date
              }
        nextToken
              }
            }`
    );
  }

  public static get ListScTripMasterBySchduleWithToken(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `($scheduled_date:String,$nextToken:String) {
              ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `(
                filter : {
                  scheduled_date : {contains : $scheduled_date}
                },
                nextToken : $nextToken
                      ) {
                       items{
                        id
                        driver_id
                        cab_id
                        status
                        trip_type
                        scheduled_date
                      }
                nextToken
                      }
                    }`
    );
  }

  public static get ListScTripMasterByCab(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `($cab_id:String) {
      ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `(
    filter : {
      cab_id : { eq : $cab_id}
    }) {
           items{
            id
            driver_id
            cab_id
            status
            trip_type
            scheduled_date
          }
    nextToken
          }
        }`
    );
  }

  public static get ListScTripMasterByCabNextToken(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `($cab_id:String,$nextToken:String) {
      ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `(
    filter : {
      cab_id : { eq : $cab_id}
    },nextToken : $nextToken) {
           items{
            id
            driver_id
            cab_id
            status
            trip_type
            scheduled_date
          }
    nextToken
          }
        }`
    );
  }

  public static get ListScTripMasterSchduleCab(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `($scheduled_date:String,$cab_id:String) {
      ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `(
        filter : {
          scheduled_date : {contains : $scheduled_date}
          cab_id : { eq : $cab_id}
        }
      ) {
               items{
                id
                driver_id
                cab_id
                status
                trip_type
                scheduled_date
              }
        nextToken
              }
            }`
    );
  }

  public static get ListScTripMasterSchduleCabNextToken(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `($scheduled_date:String,$cab_id:String,$nextToken:String) {
      ` +
      this.list +
      this.env +
      this.listScTripMasters +
      `(
        filter : {
          scheduled_date : {contains : $scheduled_date}
          cab_id : { eq : $cab_id}
        },nextToken:$nextToken
      ) {
               items{
                id
                driver_id
                cab_id
                status
                trip_type
                scheduled_date
              }
        nextToken
              }
            }`
    );
  }

  public static get getScUserTripByDriver(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listScUserTrips +
      `($trip_id: String, $user_id:String) {
      ` +
      this.list +
      this.env +
      this.listScUserTrips +
      `(filter :{
        trip_id :{eq : $trip_id}
        user_id : {eq : $user_id}
      }) {
        items {
          id
          start_address{
            address
          }
          end_address{
            address
          }
          scheduled_date
        }
      }
    }`
    );
  }
  public static get getScUserTripByDriverAll(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listScUserTrips +
      `($scheduled_date: String) {
      ` +
      this.list +
      this.env +
      this.listScUserTrips +
      `(filter :{
        scheduled_date :{contains : $scheduled_date}

      }) {
        items {
          id
          user_id
          trip_status
          trip_type
          otp
          is_boarded
          drop_point
          scheduled_date
          start_address{
            address
          }
          end_address{
            address
          }
        }
      }
    }`
    );
  }

  public static get getScUserTripByTripIdAllFields(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listScUserTrips +
      `($trip_id: String) {
      ` +
      this.list +
      this.env +
      this.listScUserTrips +
      `(filter :{
        trip_id :{eq : $trip_id}

      }) {
        items {
          user_id
          trip_status
          trip_type
          otp
          is_boarded
          drop_point
          scheduled_date
          start_address{
            address
            lat
            long
          }
          end_address{
            address
            lat
            long
          }
        }
      }
    }`
    );
  }

  public static get GetScUserTripTripId(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listScUserTrips +
      `($trip_id: String) {
      ` +
      this.list +
      this.env +
      this.listScUserTrips +
      `(filter :{
        trip_id :{eq : $trip_id}
            }) {
        items {
          scheduled_date
          drop_point
          user_id
          otp
        }
      }
    }`
    );
  }
  public static get GetScUserTripUser(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listScUserTrips +
      `($trip_id: String) {
      ` +
      this.list +
      this.env +
      this.listScUserTrips +
      `(filter :{
        trip_id :{eq : $trip_id}
            }) {
        items {
          user_id
          end_address{
            address
            lat
            long
          }
          start_address{
            address
            lat
            long
          }
        }
      }
    }`
    );
  }

  public static get GetScUserTripUserId(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listScUserTrips +
      `($trip_id: String,$user_id: String,$scheduled_date: String) {
      ` +
      this.list +
      this.env +
      this.listScUserTrips +
      `(filter :{
        trip_id :{eq : $trip_id}
        user_id :{eq : $user_id}
        scheduled_date :{eq : $scheduled_date}
            }) {
        items {
         id
        }
      }
    }`
    );
  }

  public static get GetScUserTripId(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listScUserTrips +
      `($trip_id: String) {
      ` +
      this.list +
      this.env +
      this.listScUserTrips +
      `(filter :{
        trip_id :{eq : $trip_id}
            }) {
        items {
         id
        }
      }
    }`
    );
  }

  public static get GetScUserTripByTripId(): string {
    return (
      `query  ` +
      this.list +
      this.env +
      this.listScUserTrips +
      `($trip_id: String) {
      ` +
      this.list +
      this.env +
      this.listScUserTrips +
      `(filter :{
        trip_id :{eq : $trip_id}
            }) {
        items {
          id
        }
      }
    }`
    );
  }
  public static get GetRncUsers(): string {
    return (
      `query  ` +
      this.getq +
      this.env +
      this.RncUsers +
      `($id: ID!) {
      ` +
      this.getq +
      this.env +
      this.RncUsers +
      `(id : $id) {
          name
          employee_phone
          user_name
          user_type
          agency_type
      }
    }`
    );
  }
  //Get the Driver

  public static get ListDaTrips(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.DaTrips +
      `($created_at: String) {

      ` +
      this.list +
      this.env +
      this.DaTrips +
      `(filter :{
        created_at :{ge : $created_at}
            }) {` +
      this.DaTripsItmes +
      ` }
    }`
    );
  }

  public static get getMiscData(): string {
    return (
      `query ` +
      this.list +
      this.env +
      this.listMiscData +
      `($data_key:String)
     {
      ` +
      this.list +
      this.env +
      this.listMiscData +
      `(filter:{
         data_key:{eq:$data_key}
       }){
         items{
           id
           data_key
           data_value
         }
       }
     }`
    );
  }

  public static get updateMiscDataByKey(): string {
    return (
      `mutation ` +
      this.update +
      this.env +
      this.updateMiscData +
      `($id:ID!, $data_key:String, $data_value: String) {
      ` +
      this.update +
      this.env +
      this.updateMiscData +
      `(input: {id: $id, data_key: $data_key, data_value: $data_value}) {
            id
            data_key
            data_value
        }
      }`
    );
  }

  //UPDATE FUEL CARD MASTER
  public static get updateFuelCardMaster(): string {
    return (`mutation ` +
      this.update +
      this.env +
      this.FuelMasterCard +
      `(
      $id: ID!,
      $status: String
      $updated_date: String
      ) {
      ` +
      this.update +
      this.env +
      this.FuelMasterCard +
      `(input:{
        id: $id,
        status: $status
        updated_date: $updated_date
        }) {
        id
        card_expiry_date
        card_number
        card_provider
        updated_date
        status
      }
    }`);
  }
}
